import React, { useState } from "react";

import ValidatorAllPage from "./ValidatorAll";
import ValidatorSubmittedPage from "./ValidatorSubmitted";
import ValidatorUpdatesPage from "./ValidatorUpdates";
import ValidatorAcceptedPage from "./ValidatorAccepted";
import ValidatorRejectedPage from "./ValidatorRejected";

function Validate({userDetails, setParentLoading, activeValidatorTab}){
return (
        <div >
             
                {/* CONTENTS */}

                <div
                    style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    padding: "10px",
                    boxSizing: "border-box"
                }}
                >

                    {/* ALL */}

                    {activeValidatorTab === "validatorall" &&
                        <div className="fade-container">
                          <ValidatorAllPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* SUBMITTED */}

                    {activeValidatorTab === "validatorsubmitted" &&
                        <div className="fade-container">
                          <ValidatorSubmittedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    

                    {/* UPDATES */}

                    {activeValidatorTab === "validatorupdates" &&
                        <div className="fade-container">
                          <ValidatorUpdatesPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* ACCEPTED */}

                    {activeValidatorTab === "validatoraccepted" &&
                        <div className="fade-container">
                          <ValidatorAcceptedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* REJECTED */}

                    {activeValidatorTab === "validatorrejected" &&
                        <div className="fade-container">
                          <ValidatorRejectedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }
                   

                </div>

        </div>
    )
}

export default Validate;